import { literal, string, struct } from 'io-ts/lib/Decoder';

import { Segment } from '../frame/Segment';

/**
 * Sent when a segment is updated.
 * Server will recompute the frame geometry after update.
 */
export const SegmentUpdated = struct({
	type: literal('segment-updated'),
	frameId: string,
	segment: Segment,
});
